// @flow
import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';
import Button from '@rover/react-lib/components/buttons/Button';
import Popover from '@rover/react-lib/components/callouts/Popover';
import { EmergencyFormConstants } from '@rover/shared/js/constants/translation';

type Props = {
  isComplete: boolean,
  buttonText: string,
  saveMethod: () => void,
  wantingToEdit: Object,
  disabled: boolean,
};

const SaveButtonWrapper: StyledComponent<{}> = styled.div`
  text-align: center;
`;

const SectionSaveButton = ({
  isComplete,
  buttonText,
  saveMethod,
  wantingToEdit,
  disabled,
}: Props): Node => (
  <div>
    {!isComplete || Object.values(wantingToEdit).some(currentlyEditing => currentlyEditing) ? (
      <SaveButtonWrapper>
        <Popover
          event={disabled ? Popover.Event.HOVER : Popover.Event.NONE}
          placement={Popover.Placement.TOP}
          content={EmergencyFormConstants.saveDisabledMessage}
        >
          <Button disabled={disabled} marginBottom="8x" onClick={saveMethod}>
            {buttonText}
          </Button>
        </Popover>
      </SaveButtonWrapper>
    ) : (
      <div />
    )}
  </div>
);

SectionSaveButton.defaultProps = {
  wantingToEdit: {},
  disabled: false,
};

export default SectionSaveButton;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/common/SectionSaveButton.jsx